@if (cliente) {
  <section class="cliente-info">
    <!-- Resumen: cuánto tiene el cliente (con sus hijos). La identidad
         (nombre, número, tipo, estado) está en el encabezado. -->
    @if (conteos.length) {
      <app-dt-card>
        <app-dt-datos destacado>
          @for (c of conteos; track c.titulo) {
            <app-dt-dato [etiqueta]="c.titulo" [valor]="c.valor" />
          }
        </app-dt-datos>
      </app-dt-card>
    }

    <div class="cliente-grilla">
      <div class="cliente-columna">
        <app-dt-card titulo="Cliente" icono="business">
          <app-dt-datos>
            <app-dt-dato
              etiqueta="Número de cliente"
              [valor]="cliente.numeroCliente"
              mono
              copiable
            />
            <app-dt-dato etiqueta="Fecha de creación" [valor]="fechaCreacion" />
          </app-dt-datos>
        </app-dt-card>

        <app-dt-card titulo="Módulos" icono="widgets">
          @if (modulos.length) {
            <div class="cliente-modulos">
              @for (m of modulos; track m) {
                <span class="cliente-modulo">{{ m }}</span>
              }
            </div>
          } @else {
            <span class="dt-muted">Sin módulos activos</span>
          }
        </app-dt-card>

        @if (puedeVerReenvios) {
          <app-dt-card titulo="Reenvíos" icono="forward_to_inbox">
            @if (reenvios; as r) {
              <app-dt-datos>
                <app-dt-dato etiqueta="Reglas de reenvío" [valor]="r.activas">
                  <button
                    irxBotonIcono
                    tamano="mini"
                    [disabled]="!r.total"
                    (click)="verReenvios()"
                    [tooltip]="
                      r.total
                        ? 'Ver reglas de reenvío'
                        : 'Sin reglas de reenvío'
                    "
                  >
                    <mat-icon>visibility</mat-icon>
                  </button>
                </app-dt-dato>
                @if (r.alcance.length) {
                  <app-dt-dato etiqueta="Alcance" ocultarVacio>
                    @for (a of r.alcance; track a) {
                      <span class="cliente-linea">{{ a }}</span>
                    }
                  </app-dt-dato>
                }
                @if (r.metodos) {
                  <app-dt-dato etiqueta="Métodos" [valor]="r.metodos" />
                }
                @if (r.heredadas) {
                  <app-dt-dato
                    etiqueta="Heredadas de un ancestro"
                    [valor]="'' + r.heredadas"
                  />
                }
              </app-dt-datos>
            } @else {
              <!-- Hasta tenerlas no se dice "No hay activas" -->
              <span class="dt-muted">Cargando…</span>
            }
          </app-dt-card>
        }
      </div>

      <app-dt-card
        titulo="Jerarquía"
        icono="account_tree"
        class="cliente-jerarquia"
      >
        <app-jerarquia-cliente
          [idCliente]="cliente._id"
          [chartHeight]="420"
        ></app-jerarquia-cliente>
      </app-dt-card>
    </div>
  </section>
}
